import hotjar from '@hotjar/browser';
import mixpanel from 'mixpanel-browser';

import { IS_DEVELOPMENT } from 'shared/config/env';

import type { Analytics as AnalyticsType } from './types';
import type { AnalyticsEvent } from 'applications/GSP/shared/constants/analytics';
import type { Mixpanel, Dict } from 'mixpanel-browser';

const { REACT_APP_ANALYTICS_TOKEN: token, REACT_APP_HOTJAR_ID: hotjarId } =
  process.env;

const hotjarVersion = 6;
const mixpanelOptions = {
  debug: IS_DEVELOPMENT,
  secure_cookie: true,
};

class Analytics implements AnalyticsType {
  private analytics?: Mixpanel = undefined;

  init() {
    if (this.analytics) return;

    if (token) {
      mixpanel.init(token, {
        ...mixpanelOptions,
        loaded: (mixpanel: Mixpanel) => {
          this.analytics = mixpanel;
        },
      });
    } else if (IS_DEVELOPMENT) {
      window.console.warn('Analytics: Please provide mixpanel token.');
    }

    if (hotjarId) {
      hotjar.init(Number(hotjarId), hotjarVersion);
    } else if (IS_DEVELOPMENT) {
      window.console.warn('Analytics: Please provide hotjar id.');
    }
  }

  identify(id?: string) {
    this.analytics?.identify(id);
  }

  register(props: Dict, days?: number) {
    this.analytics?.register(props, days);
  }

  track(eventName: AnalyticsEvent | undefined, props: Dict) {
    if (!eventName) return;

    this.analytics?.track(eventName, props);
  }

  timeEvent(eventName?: AnalyticsEvent) {
    if (!eventName) return;

    this.analytics?.time_event(eventName);
  }

  trackPageView(properties: Dict) {
    this.analytics?.track_pageview(properties);
  }
}

export const analytics = new Analytics();
